import { TableDueDateCell } from '../../Table'
import { isTaskDone } from '../Task.utils'

import { getColorProperties } from './TaskTableRowDeadline.utils'

function TaskTableRowDeadline({ item, ...restProps }) {
  const { deadline } = item

  const done = isTaskDone(item)

  return (
    <TableDueDateCell
      {...restProps}
      getColorProperties={getColorProperties}
      status={done}
      value={deadline}
    />
  )
}

export default TaskTableRowDeadline
